export const SITE_URL: string =
  import.meta.env.VITE_SITE_URL || 'https://usfanssheet.link';

export const SITE_NAME = 'USFansSheet.link';